import { NgModule } from '@angular/core';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextareaComponent } from './input-textarea.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [InputTextareaComponent],
  imports: [CommonModule, InputTextareaModule, ReactiveFormsModule],
  exports: [InputTextareaComponent],
})
export class InputTextareaComponentModule {}
